import * as React from "react"

import { useHubSpotForm } from "./use-hubspot"

const hubspotScriptSrc = `//js.hsforms.net/forms/v2.js`

function HubSpotForm({ formId, portalId }) {
  const [formCreated, setFormCreated] = React.useState(false)
  const [loaded, setLoaded] = React.useState(false)

  useHubSpotForm({
    callback: () => setFormCreated(true),
    formCreated,
    formId,
    loaded,
    portalId,
  })

  const onError = React.useCallback(error => {
    console.error("HubSpot Forms error:", error)
    setLoaded(false)
    setFormCreated(false)
  }, [])

  const onLoad = React.useCallback(() => setLoaded(true), [])

  const loadScript = React.useCallback(() => {
    const script = document.createElement(`script`)
    script.onError = onError
    script.onload = onLoad
    script.defer = true
    script.src = hubspotScriptSrc
    document.head.appendChild(script)
  }, [onLoad, onError])

  React.useEffect(() => {
    loadScript()
  }, [loadScript])

  return <>{loaded && <div data-hubspot-forms-id={formId} />}</>
}

export default HubSpotForm
